module.exports = __webpack_public_path__ + "img/bbf7ca2.jpg";